import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  submitButton: {
    display: 'none',
  },
}));
